import type { KbAdminEditorSectionProps } from "./kbAdminEditorProps";
import { KbAiDetailsGuidanceAndPurpose } from "./ai-details/KbAiDetailsGuidanceAndPurpose";
import { KbAiDetailsHeaderBar } from "./ai-details/KbAiDetailsHeaderBar";
import { KbAiDetailsResponseWindow } from "./ai-details/KbAiDetailsResponseWindow";
import { KbAiDetailsRunAndGapBlocks } from "./ai-details/KbAiDetailsRunAndGapBlocks";

export function KbAdminEditorAiDetails(props: KbAdminEditorSectionProps) {
  const { aiHelpOpen, setAiHelpOpen } = props;

  if (!aiHelpOpen) return null;

  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50/40 overflow-hidden shadow-sm dark:border-amber-700 dark:bg-amber-950/25">
      <KbAiDetailsHeaderBar onClose={() => setAiHelpOpen(false)} />
      <div className="px-3 py-3 space-y-3">
        <KbAiDetailsGuidanceAndPurpose {...props} />
        <KbAiDetailsRunAndGapBlocks {...props} />
        <KbAiDetailsResponseWindow {...props} />
      </div>
    </div>
  );
}
